'use strict';

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var $options = '';

/**
*
* ------------------------------------------------------------------------------
*
*
* @namespace sidecart
*/

var $cart = {
  trigger_open: '.cart-trigger',
  trigger_close: '.sidecart-overlay, .sidecart-close'
};

(0, _jquery2.default)(document).ready(function () {
  listeners();
  add_variant_options();
});

function listeners() {
  (0, _jquery2.default)(document).on('click', $cart.trigger_open, function () {
    (0, _jquery2.default)('body').addClass('sidecart-open');
  });
  (0, _jquery2.default)(document).on('click', $cart.trigger_close, function () {
    (0, _jquery2.default)('body').removeClass('sidecart-open');
  });
  (0, _jquery2.default)(document).on('click', '.sidecart-variant-switcher-display', function () {
    (0, _jquery2.default)(this).parent().toggleClass('toggle-open');
  });
  (0, _jquery2.default)(document).on('click', '.sidecart-variant-switcher-options span', function () {
    (0, _jquery2.default)('.sidecart-variant-switcher').removeClass('toggle-open');
    var $variant_current = (0, _jquery2.default)(this).attr('data-current-id');
    var $variant_new = (0, _jquery2.default)(this).attr('data-new-id');
    switch_variant($variant_current, $variant_new);
  });
}

function update_sidecart_upsells() {
  var product_type = '';
  if (CartJS.cart.item_count > 0) {
    var product_type = CartJS.cart.items[0].product_type;
  } else {
    (0, _jquery2.default)('.sidecart-container').removeClass('has-rec');
  }

  (0, _jquery2.default)('.sidecart-recommendation').removeClass('show');
  if ((0, _jquery2.default)('.sidecart-recommendation[data-type="' + product_type + '"]').length > 0) {
    console.log('Recommendation Found!');
    (0, _jquery2.default)('.sidecart-container').addClass('has-rec');
  } else {
    (0, _jquery2.default)('.sidecart-container').removeClass('has-rec');
  }
  (0, _jquery2.default)('.sidecart-recommendation[data-type="' + product_type + '"]').addClass('show');
}

function switch_variant($variant_current, $variant_new) {
  CartJS.removeItemById($variant_current);
  CartJS.addItem($variant_new, 1, {});
}